import React, { useCallback } from "react";
import { useEffect, useState } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BTable from 'react-bootstrap/Table';
import { HeaderList } from "../../../components/HeaderList";
import { VerticalBarChart } from "../../../components/VerticalBarChart";
import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { BranchService } from "../../../services/branch.service";
import { BranchModel } from "../../../models/branch.model";
import { EquipmentModel } from "../../../models/equipment.model";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";
import { EventExportService } from "../../../services/eventExport.service";

import { EquipmentAcknowledgeService } from "../../../services/equipmentacknowledge.service";

import storageService from "../../../services/storage.service";
import UtilService from "../../../services/util.service";
import { useTable, usePagination, useSortBy } from 'react-table';
import { faSortAlphaUp, faSortAlphaDown, faSort, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import HelperService from "../../../services/helper.service";
import { ButtonClean, ButtonSearch, ButtonExport } from "../../../components/buttons";
import moment from "moment";

import { GroupModel } from "../../../models/group.model";
import { GroupService } from "../../../services/group.service";

import {
  faLineChart,
  faChartGantt,
  faChartColumn
} from '@fortawesome/free-solid-svg-icons';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Chart } from "react-google-charts";
import { HorizontalBarChart } from "../../../components/HorizontalBarChart";

function Table({columns, data, update, total_records, msgEmpty }) {
  let columnsToHidden = [];
  
  if (columns) {
    for (let i = 0; i < columns.length; i++) {
      const colFather = columns[i];
      if (colFather.columns) {
        for (let j = 0; j < colFather.columns.length; j++) {
          const colChild = colFather.columns[j];
          if (colChild.isVisible !== undefined && colChild.isVisible === false) {
            columnsToHidden.push(colChild.id || colChild.accessor);
          }
        }
      }
      else {
        if (colFather.isVisible !== undefined && colFather.isVisible === false) {
          columnsToHidden.push(colFather.id || colFather.accessor);
        }
      }
    }
  }


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: columnsToHidden
      },
    },
    useSortBy,
    usePagination
  )

  const formatCellStyleHeader = (cellInfo: any) => {
    const style = {
      border: 'none',
      color: '#2196F3',
      fontWeight: 700,
      textAlign: 'left'
    };
    return style;
  }

  const formatCellStyle = (cellInfo: any) => {
    const style = {
      width: '100%',
      height: '100%',
      padding: 2,
    };

    const columnId = cellInfo.column.id;
    let dayName = "";

    switch (columnId) {
      case "d01Value":
        dayName = "d01";
        break;
      case "d02Value":
        dayName = "d02";
        break;
      case "d03Value":
        dayName = "d03";
        break;
      case "d04Value":
        dayName = "d04";
        break;
      case "d05Value":
        dayName = "d05";
        break;
      case "d06Value":
        dayName = "d06";
        break;
      case "d07Value":
        dayName = "d07";
        break;
    }

    return style;
  }



  return (
    <>
      <BTable hover size="sm" {...getTableProps()} style={{ width: '99.9%' }}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.filter(x => !x.columns).map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={formatCellStyleHeader(column)}
                >
                  <div style={{ display: "inline-flex", alignItems: "center" }}>
                    <div style={{ display: "table-caption" }}>
                      {column.render('Header')}
                    </div>
                    {column.canSort
                      ? column.isSorted
                        ? <FontAwesomeIcon icon={column.isSortedDesc ? faSortAlphaDown : faSortAlphaUp} />
                        : <FontAwesomeIcon icon={faSort} />
                      : null
                    }
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row)
            const isUpdated = row.original.isUpdated;
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {

                  if (cell.column.id.indexOf("d01") !== -1 && !isUpdated) {
                    return <td
                      colSpan={7}
                      {...cell.getCellProps()}
                      style={{
                        background: "#fff",
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        color: '#555',
                        padding: 0,
                        opacity: isUpdated ? 1 : 0.65
                      }}
                    >
                      <div style={formatCellStyle(cell)}>
                        {msgEmpty}
                      </div>
                    </td>
                  }

                  if (!isUpdated && cell.column.id.indexOf("d0") !== -1) {
                    return <></>;
                  }
                  return (
                    <td
                      {...cell.getCellProps()}
                      
                    >
                      <div style={formatCellStyle(cell)}>
                        {cell.render('Cell')}
                      </div>
                    </td>
                  )
                }
                )}
              </tr>
            )
          })}
        </tbody>
      </BTable>
    </>
  );
}

const InconsistentList = () => {
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const user = storageService.getUser();
  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'equipment',
    filters: {
      branch_id: [],
      group_id:[],
      validade_config_feature:[false],
      date_begin_end:[],
    /* Sprint 29 - Adicionando os filtro por status */
      status: ['PENDING', 'ON_LATE', 'ON_TIME'],
    /* Sprint 29 - Adicionando os filtro por status */
    /* Array de equipment para filtro - Sprint 30*/
    code_equipment: []
    },
    parameters: {}
  });

  const [datasetBranch, setDatasetBranch] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'branch',
    filters: {
      group_id:[],
      /* Sprint 29 - Adicionando os filtro por status */
      status: ['PENDING', 'ON_LATE', 'ON_TIME'],
      /* Array de equipment para filtro - Sprint 30*/
      code_equipment: []
    },
    pagination: {
      page_number: 1,
      total_pages: 0,
      records_pages: 500,
      total_records: 0
    },
  });

  const [selectedDataDashboard, setSelectedDataDashboard] = useState(null);
  const [branches, setBranches] = useState<BranchModel[]>();

  const [group, setGroup] = useState<GroupModel[]>();
  const [newDataChart, setNewDataChart] = useState<any>();
  
  const [equipments, setEquipments] = useState<EquipmentModel[]>();
  const [codeEquipment, setCodeEquipment] = useState<string>();
  const [datasetDashboardAnalytical, setDatasetDashboardAnalytical] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'equipment',
    filters: {
      branch_id: [],
      group_id:[],
      validade_config_feature:[false],
      date_begin_end:[],
      status: ['PENDING', 'ON_LATE', 'ON_TIME'],
      code_equipment: []
      
    },
    pagination: {
      page_number: 1,
      total_pages: 0,
      records_pages: 21,
      total_records: 0
    },
  });


  const data = React.useMemo(() => datasetDashboardAnalytical?.data || [], [ , datasetDashboardAnalytical?.data, selectedDataDashboard]);

  const columns = React.useMemo(
    () => [
      {
        Header: t("INCONSISTENT.EQUIPMENT"),
        background: '#4b4b50',
        columns: [
            {
              Header: props => (<span>{t("INCONSISTENT.REGIONAL")}</span>),
              accessor: "regional",
              background: '#999999',
              disableSortBy: true,
              Cell: props => (props.value)
            }
            ,
            {
              Header: props => (<span>{t("INCONSISTENT.BRANCH")}</span>),
              accessor: "nickname",
              background: '#999999',
              disableSortBy: true,
              Cell: props => (props.value)
            },           
            {
              Header: props => (<span>{t("INCONSISTENT.EQUIPMENT")}</span>),
              accessor: "code_equipment",
              background: '#999999',
              disableSortBy: true,
              Cell: props => (props.value)
            },       
            {
              Header: props => (<span>{t("INCONSISTENT.PICKUP_PERCENT")}</span>),
              accessor: "percent_pickup",
              background: '#999999',
              disableSortBy: true,
              Cell: props => (props.value)
            },    
            {
              Header: props => (<span>{t("INCONSISTENT.1ST_IMPOSITION")}</span>),
              accessor: "imposed_pickup_date",
              background: '#999999',
              disableSortBy: true,
              Cell: props => (formatDateTime(props.value))
            },
            {
              Header: props => (<span>{t("INCONSISTENT.DAYS_WITHOUT_COLLECTION")}</span>),
              accessor: "days_since_imposed_pickup",
              background: '#999999',
              disableSortBy: true,
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("INCONSISTENT.COLLECTION_DATE")}</span>),
              accessor: "next_pickup_history_by_ssp",
              background: '#999999',
              disableSortBy: true,
              Cell: props => (formatDateTime(props.value))
            }
            ,
            {
              Header: props => (<span>{t("EQUIPMENT.STATUS")}</span>),
              accessor: "limit_exceeded_status",
              background: '#999999',
              disableSortBy: true,
              Cell: props => renderStatus(props.value)
            }

        ]
      },
    ],
    []
  );

  const formatDateTime = (value) => {
    return UtilService.formatDate(value, user.locale.formatDate);
  };

  const renderStatus = (value) => {
    return(value == 'PENDING' ? <span className="text-danger">{t("INCONSISTENT." + value)}</span> : t("INCONSISTENT." + value))
  }

  const formatToCurrency = (value) => {
    let decimalSeparator = user.locale?.decimalSeparator;
    let thousandSeparator = user.locale?.thousandSeparator;
    let moneyPrefix = user.locale?.moneyPrefix;
    return HelperService.number_format(value, 2, decimalSeparator, thousandSeparator);
  };

  const initialize = async () => {
    BranchService.getAllList().then((response: any) => {
      if(response.success){
        let branchList = response.result.datasets.filter((dataset)=>{return dataset.dataset === 'branch'});
        if (branchList[0].data != null)
        {
          const sort = branchList[0].data.sort((a, b) => a.fullName.localeCompare(b.fullName))
          setBranches(sort);
        }
        else
        setBranches([]);
      }else{
        setBranches([]);
      }
    });

    GroupService.getAll().then((response: any) => {
      if(response.success){
        let groupList = response.result;
        const sort = groupList.sort((a, b) => a.fullName.localeCompare(b.fullName)).filter(t=>t.inconsistentForecastAnalysis === true);
        setGroup(sort);
      }else{
        setGroup([]);
      }
    });

    await getList({
      page_number:1
    })
  };

  const exportFile = async () => { 
    getListExport(null);
  };


  const getListExport = async (dataTable) => {
    setLoading(true);

    const type= 'Excel';

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    requestParams.parameters = {
      ...requestParams.parameters,
      type
    }

    EventExportService.ExportEquipmentForcedWithoutCollection(requestParams,type).finally(() =>
      type
    );
    setLoading(false)
  };


  const getList = async (dataTable) => {
    setLoading(true);

    let dba = datasetDashboardAnalytical;

    const trimdocument = dba.filters.code_equipment?.[0]?.trim() || "";

    dba.filters = { 
        ...dba.filters, 
        all_pending: [allPending],
        ...(trimdocument ? { code_equipment: [trimdocument] } : {}),
    } 

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dba] };

    requestParams.parameters = {
      ...requestParams.parameters
    }

  const response: any = await EquipmentAcknowledgeService.getEquipmentForcedCollection(requestParams);

    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'equipment' }));
      setDatasetDashboardAnalytical(d);
      setNewDataChart(d.data);
    }
    else {
      requestParams.datasets[0].data = null;
      setDatasetDashboardAnalytical(requestParams.datasets[0]);
    }

    setLoading(false);
  };


  /*
    Sprint 29
    Adicionando os status para fazer a pesquisa.
  */
    const handleSearch = async (event) => {
      if (event != null)
        event.preventDefault();
  
      if (startDate || endDate) {
        setDatasetDashboardAnalytical({ 
          ...datasetDashboardAnalytical, 
          filters: { 
            ...datasetDashboardAnalytical.filters, 
            date_begin_end: [startDate, endDate]
          } 
        });
        setDataset({ 
          ...dataset, 
          filters: { 
            ...datasetDashboardAnalytical.filters, 
            date_begin_end: [startDate, endDate]
          } 
        });
      }
  
      await getList({
        page_number: 1
      });
    };
  
    /*
      Sprint 29
      Adicionando o array de staus, depois de clicar no clean e vim todos marcados

      Sprint 30 - Adicionando o array de code_equipement
    */

      const [flagClear, setFlagClear] = useState(false);

      useEffect(() => {
        if (flagClear)
        {
            handleSearch(null);
            setFlagClear(false);
        }
      }, [flagClear]);

      const handleClean = (event) => {    

        setDataset({
          ...dataset, 
          filters: { 
            branch_id: [], 
            group_id: [], 
            validade_config_feature: [false], 
            date_begin_end: [], 
            status: ['PENDING', 'ON_LATE', 'ON_TIME'],
            code_equipment: [] 
          } 
        });
        setDatasetDashboardAnalytical({ 
          ...datasetDashboardAnalytical, 
          filters: { 
            branch_id: [], 
            group_id: [], 
            validade_config_feature: [false], 
            date_begin_end: [], 
            status: ['PENDING', 'ON_LATE', 'ON_TIME'],
            code_equipment: []  
          } 
        });
        setCodeEquipment('');
        setStartDate(null);
        setEndDate(null);
        setMaxDate(moment().toDate())
        FilterGroup = { 
          ...datasetBranch, 
          filters: { 
            ...datasetBranch.filters, 
            group_id: [], 
            status: ['PENDING', 'ON_LATE', 'ON_TIME'] 
          } 
        };
        BranchService.getAllList().then((response: any) => {
          if (response.success) {
            let branchList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'branch' });
            const sort = branchList[0].data.sort((a, b) => a.fullName.localeCompare(b.fullName))
            setBranches(sort);
          } else {
            setBranches([]);
          }
        });
        setStartDate(moment().add(-30, "day").toDate());
        setEndDate(moment().toDate());
        setFlagClear(true);
        setAllPending(false);
      };

  const [maxDate, setMaxDate] = useState(moment().toDate())
  const calcMaxDate = (start, end) => {
    if (end)
      return moment().toDate();
    let startDate = moment(start).add(29, "day").toDate();    
    return moment().toDate() > (startDate) ? startDate : moment().toDate();
  }

  const [startDate, setStartDate] = useState(moment().add(-30, "day").toDate())
  const [endDate, setEndDate] = useState(moment().toDate())      
  const formatoData = user.locale.formatDate.replaceAll('DD', 'dd');
  const [showTotals, setShowTotals] = useState(false);
  const [horizontalChart, setHorizontalChart] = useState(false);
  const [allPending, setAllPending] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);

  useEffect(() => {
    if (buttonClicked) {
      getList({
        page_number: 1
      });
      setButtonClicked(false); // Resetando o estado para evitar chamadas repetidas
    }
  }, [buttonClicked]);

  const handleButtonClick = () => {
    setAllPending(!allPending);
    setButtonClicked(true);
  };



  const idiom = storageService.getIdiom();

  const transformDataComponent = () => {
    let returnVal = [];
    if (newDataChart != null)
    {
      newDataChart.map(d => {
        if (returnVal.filter(x => x.filial == d.nickname).length == 0)
        {
        returnVal.push({regional: d.regional,
          filial: d.nickname, 
          onlate: newDataChart.filter(x => x.nickname == d.nickname && x.limit_exceeded_status == "ON_LATE").length,
          ontime: newDataChart.filter(x => x.nickname == d.nickname && x.limit_exceeded_status == "ON_TIME").length,
          pending: newDataChart.filter(x => x.nickname == d.nickname && x.limit_exceeded_status == "PENDING").length})
        }
      });
    }
    return returnVal;    
  };

  const transformTotalsDataComponent = () => {
    let regionals = [];
    let returnVal = [];
    if (newDataChart != null)
    {
      newDataChart.map(dt => {
        if (regionals.indexOf(dt.regional) === -1) {
          regionals.push(dt.regional)
        }
      });      

      returnVal.push({regional: "Total",
          filial: "Total", 
          onlate: newDataChart.filter(x => x.limit_exceeded_status == "ON_LATE").length,
          ontime: newDataChart.filter(x => x.limit_exceeded_status == "ON_TIME").length,
          pending: newDataChart.filter(x => x.limit_exceeded_status == "PENDING").length})

      regionals.map(d => {
        returnVal.push({regional: d,
          filial: d, 
          onlate: newDataChart.filter(x => x.regional == d && x.limit_exceeded_status == "ON_LATE").length,
          ontime: newDataChart.filter(x => x.regional == d && x.limit_exceeded_status == "ON_TIME").length,
          pending: newDataChart.filter(x => x.regional == d && x.limit_exceeded_status == "PENDING").length})
      });
    }
    return returnVal;    
  };

  var FilterGroup =  null;

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    // Função de alteração do seletor de staus
    const handleChangeStatus = (status) => {
      let newStatusArray = [...datasetDashboardAnalytical.filters.status];
    
      // Verifica se o status já está no array
      const index = newStatusArray.indexOf(status);
    
      // Se o status estiver no array, remove-o
      if (index !== -1) {
        newStatusArray.splice(index, 1);
      } else {
        // Se não estiver, adiciona-o
        newStatusArray.push(status);
      }
    
      // Atualiza o estado com o novo array de status
      setDatasetDashboardAnalytical({
        ...datasetDashboardAnalytical,
        filters: { ...datasetDashboardAnalytical.filters, status: newStatusArray }
      });
    };

  return (
    <>
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <HeaderList title={t(`INCONSISTENT.IMPOSED_COLLECTION`)} />
      </div>
      <Form>
        <Form.Label className="mb-1">{t("FILTERS")}</Form.Label>
        <Row className="align-items-center">
          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.group_id.length > 0 ? dataset?.filters?.group_id[0] : ''}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, group_id: [Number(e.target.value)] } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, group_id: [Number(e.target.value)] } })

                    if (isNaN(Number(e.target.value)))
                    {
                      FilterGroup = { ...datasetBranch, filters: { ...datasetBranch.filters, group_id: [] } }
                    }
                    else
                    {
                      FilterGroup = { ...datasetBranch, filters: { ...datasetBranch.filters, group_id: [Number(e.target.value)] } }
                    }
                    datasetBranch.dataset= 'branch' ;

                    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [FilterGroup] };
                    
                    BranchService.getList(requestParams).then((response: any) => {
                      if(response.success){
                        let branchList = response.result.datasets.filter((dataset)=>{return dataset.dataset === 'branch'});
                        const sort = branchList[0].data.sort((a, b) => a.fullName.localeCompare(b.fullName))
                        setBranches(sort);
                      }else{
                        setBranches([]);
                      }
                    });

                  }}
                >
                  <option>{t("FILTER.SELECT")}</option>
                  {_.map(group, (item: GroupModel) => {
                    return <option key={item.id} value={item.id}>{item.fullName}</option>
                  })}
                </Form.Control>
                <label>{t("FILTER.REGIONAL")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.branch_id.length > 0 ? dataset?.filters?.branch_id[0] : ''}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, branch_id: [Number(e.target.value)] } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, branch_id: [Number(e.target.value)] } })
                  }}
                >
                  <option>{t("FILTER.SELECT")}</option>
                  {_.map(branches, (item: BranchModel) => {
                    return <option key={item.id} value={item.id}>{item.fullName}</option>
                  })}
                </Form.Control>
                <label>{t("FILTER.BRANCH")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          {/*  
          Sprint 30
          campos para filtrar equipamentos
          */}
          <div style={{width: '11rem', marginLeft: '1rem'}} onClick={(e) => e.stopPropagation()}>
            <Form.Floating>
              <Form.Control
                name='code_equipment'
                id='code_equipment'
                type='text'
                placeholder={t(`FILTER.CODE_EQUIPMENT`)}
                className='form-control'
                onChange={(e) => {
                  const value = e.target.value;
                  setDatasetDashboardAnalytical({
                    ...datasetDashboardAnalytical,
                    filters: {
                      ...datasetDashboardAnalytical.filters,
                      code_equipment: value ? [value] : [] // Define como um array vazio se o valor estiver vazio
                    }
                  });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch(e);
                  }
                }}
                value={ datasetDashboardAnalytical?.filters?.code_equipment.length > 0
                  ? datasetDashboardAnalytical.filters.code_equipment[0]
                  : "" }
              />
              <label>{t("FILTER.EQUIPMENT")}</label>
            </Form.Floating>
            </div>

          <Col xs="auto">
              <DatePicker
                  onChange={(date) => {
                      const [ start, end] = date;

                      const retstart = (start== null ? null:moment(start).format('YYYY-MM-DD'));
                      const retend = (end== null ? null:moment(end).format('YYYY-MM-DD'));

                      const dateret = [];
                      dateret.push(retstart);
                      dateret.push(retend);


                      setDataset({ ...dataset, filters: { ...dataset.filters, date_begin_end: dateret } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, date_begin_end: dateret } })
                      
                      setStartDate(start);
                      let maxDate = calcMaxDate(start, end);
                      setMaxDate(maxDate);
                      setEndDate(maxDate > end ? end : maxDate);                      

                  }}
                  maxDate={maxDate}
                  className={'form-control mr-3'}
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat={formatoData}
                  isClearable={true}
                  disabled={allPending || (datasetDashboardAnalytical.filters.code_equipment[0] && datasetDashboardAnalytical.filters.code_equipment[0] != '')}
                  locale={idiom.replaceAll('-', '').trim()}
              />  
          </Col>

          {/*  
            Sprint 29
            Campos seletores para os status
          */}
          <Col sm={2} md={3}>
          <div className="d-inline-block" style={{ marginRight: '8px' }}>
              <Form.Check
                type='checkbox'
                id={`filterPending`}
                name={`filterPending`}
                label={t("FILTER.PENDING")}
                onChange={(event) => handleChangeStatus('PENDING')}
                disabled={allPending}
                checked={datasetDashboardAnalytical.filters.status.includes('PENDING')}
              />
            </div>
            <div className="d-inline-block" style={{ marginRight: '8px' }}>
              <Form.Check
                type='checkbox'
                id={`filterLate`}
                name={`filterLate`}
                label={t("FILTER.LATE")}
                onChange={(event) => handleChangeStatus('ON_LATE')}
                disabled={allPending}
                checked={datasetDashboardAnalytical.filters.status.includes('ON_LATE')}
              />
              </div>
              <div className="d-inline-block" >
              <Form.Check
                type='checkbox'
                id={`filterOnTime`}
                name={`filterOnTime`}
                label={t("FILTER.ON_TIME")}
                onChange={(event) => handleChangeStatus('ON_TIME')}
                disabled={allPending}
                checked={datasetDashboardAnalytical.filters.status.includes('ON_TIME')}
              />
            </div>
          </Col>          
        </Row>  
        <Row className='mt-3' style={{position: 'relative', width: '100%'}}>
          <Col xs="auto">
            <ButtonSearch onClick={(e) => handleSearch(e)} isLoading={isLoading} />
          </Col>

          <Col xs="auto">
            <ButtonClean onClick={async (e) => handleClean(e)} isLoading={isLoading}/>
          </Col>

          <Col xs="auto">
            <ButtonExport onClick={() => exportFile()} isLoading={isLoading}/>
          </Col>
          
          {/* botão pendente */}
          <Col xs="auto">
            <Button variant={allPending ? "primary" : "primary"} onClick={handleButtonClick}>
              {t("INDICATOR.PENDING_STATUS_BUTTON")}
              {allPending && <FontAwesomeIcon icon={faSquareCheck} className='ms-2' />}
            </Button>
          </Col>

          <Col xs="auto" style={{position: "absolute", right: "0px", display: 'flex', flexDirection: 'row-reverse', gap: '5px'}}>
            <Button variant={showTotals ? "primary" : "outline-primary"} onClick={() => setShowTotals(!showTotals)}>
              <FontAwesomeIcon icon={faLineChart} className='me-2' />
              <span>{t("TOTALS")}</span>
            </Button>
            <Button variant={!horizontalChart ? "primary" : "outline-primary"} onClick={() => setHorizontalChart(!horizontalChart)}>
              <FontAwesomeIcon icon={faChartGantt} />
            </Button>
            <Button variant={horizontalChart ? "primary" : "outline-primary"} onClick={() => setHorizontalChart(!horizontalChart)}>
              <FontAwesomeIcon icon={faChartColumn} />
            </Button>
          </Col>
        </Row>
      </Form>
          <br />
         { /**
           * sprint3200
           * Passando o showTotals no total, 
           * para o componente e assim poder usar ele.
           */}
      {!showTotals && !horizontalChart && <Row>
        <>
        {newDataChart && <VerticalBarChart data={transformDataComponent()} groupLegend={true} orderGroup={true} showTotals={showTotals} />}
        </>
      </Row>}
      {showTotals && !horizontalChart && <Row>
        <>
        {newDataChart && <VerticalBarChart data={transformTotalsDataComponent()} groupLegend={false}  orderGroup={false}  showTotals={showTotals}/>}
        </>
      </Row>}
      <br/>
      {!showTotals && horizontalChart && <Row>
        <>
        {newDataChart && <HorizontalBarChart data={transformDataComponent()} groupLegend={true} orderGroup={true} showTotals={showTotals} />}
        </>
      </Row>}
      {showTotals && horizontalChart && <Row>
        <>
        {newDataChart && <HorizontalBarChart data={transformTotalsDataComponent()} groupLegend={false}  orderGroup={false} showTotals={showTotals} />}
        </>
      </Row>}
      <br/>
      <Row className="align-items-center pb-3">
        <Col sm={12}>          
          <Table
            data={data}
            columns={columns}
            update={null}
            total_records={21}
            msgEmpty={t('DASHBOARD.IS_NOT_UPDATED')} />
        </Col>
      </Row>
    </>
  );
};

export default InconsistentList;
